<template>
  <div class="button-row-container">
    <footer-buttons
      :category="category"
      :flashcard="flashcard"
    ></footer-buttons>
    <div
      class="right-buttons"
    >
      <button
        class="submit-button"
        :disabled="!canSubmitAnswer"
        @click="submitAnswer"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import FooterButtons from '@/components/flashcards-v2/fragments/FooterButtons.vue';

export default {
  components: {
    FooterButtons,
  },
  props: {
    canSubmitAnswer: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: () => {},
    },
    flashcard: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    submitAnswer() {
      this.$emit('answer');
      this.$store.commit('ui/setShowAssetTray', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-row-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #F9FAFB;
  z-index: 10;
}

.submit-button {
  background-color: #155eef;
  color: white;
  height: rem-calc(48);
  font-weight: 600;
  font-size: rem-calc(18);
  padding-right: rem-calc(38);
  padding-left: rem-calc(38);
  border-radius: rem-calc(8);

  &:disabled {
    background-color: #B2CCFF;
  }
}

@include breakpoint(tablet) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
  }
}

@include breakpoint(desktop) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
    padding: 0rem 2rem 2rem;
  }
}
</style>
